/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PricePolicyPage = lazyLoad(
  () => import('./index'),
  module => module.PricePolicyPage
);
